import Container from '@/components/Container';
import FeatureUsage from './feature-usage';
import UsersActive from './users-active';
import MostUsedFeatures from './most-used-features';
import SchoolMoodComponent from './school-mood';
import Header from './header';
import Filters from './filters';
import Title from './title';
import Divider from '@/components/Divider';
import { AdminTabs, AdminTabsEnum } from '../../admin/components/tabs';
import { useEffect } from 'react';
import { useAdminStore } from '../../admin/store/useAdmin.store';

export default function DashboardPage() {
  const { onInit } = useAdminStore();

  useEffect(() => {
    onInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <AdminTabs activeTab={AdminTabsEnum.SchoolDashboard} />

      <Title />
      <div className="mx-5">
        <Divider />
      </div>
      <Filters />
      <Container className="mt-10 min-h-[46rem]">
        <div className="col-span-4 flex flex-col gap-10 md:col-span-12 md:col-end-11 lg:col-start-3 ">
          <div className=" grid grid-cols-1 gap-4 md:grid-cols-4">
            <Header />
          </div>

          <div className=" grid grid-cols-1 gap-4 md:grid-cols-2">
            <div className="w-full rounded-2xl border border-[#777]">
              <SchoolMoodComponent />
            </div>
            <div className="rounded-2xl border border-[#777]">
              <MostUsedFeatures />
            </div>
          </div>

          <div className="grid grid-cols-1">
            <div className="rounded-2xl border border-[#777]">
              <FeatureUsage />
            </div>
          </div>

          <div className="grid grid-cols-1">
            <div className="rounded-2xl border border-[#777]">
              <UsersActive />
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}
